module.exports = __webpack_public_path__ + "img/qwen-batch-lamp-04.b11e6029.webp";